<template>
  <div id="question-setting" class="mt-2 card-wrp">
    <b-card no-body class="py-2 px-3 container-card">
      <b-row>
        <b-col cols="12">
          <div class="font-medium-5 text-black">ตั้งค่าการแสดงผล</div>
          <b-row class="mt-2">
            <b-col cols="12" md="6">
              <div class="d-flex">
                <div class="mr-4 mt-5px">
                  <b-form-radio
                    v-model="formData.settingAns"
                    name="setting-ans"
                    class="custom-radio-group"
                    value="1"
                  />
                </div>
                <div class="font-medium-4">
                  <div class="text-black font-weight">เฉลยคำตอบทันที</div>
                  <div class="text-black">
                    ผู้เล่นสามารถดูเฉลยที่ตอบผิดได้ทันที
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="6">
              <div class="d-flex">
                <div class="mr-4 mt-5px">
                  <b-form-radio
                    v-model="formData.settingAns"
                    class="custom-radio-group"
                    name="setting-ans"
                    value="2"
                  />
                </div>
                <div class="font-medium-4">
                  <div class="text-black font-weight">เฉลยคำตอบทีหลัง</div>
                  <div class="text-black">ผู้เล่นสามารถดูเฉลยท้ายเกมได้</div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    formData: { type: Object },
  },
};
</script>

<style>
#question-setting.card-wrp {
  padding: 0 120px;
}

#question-setting .font-weight {
  font-weight: bold;
}

#question-setting .mt-5px {
  margin-top: 5px;
}
</style>